"use client";

/**
 * Floating mobile CTA — appears on viewports <lg after scrolling past the Hero.
 * CR11: conversion-recovery for long-scroll mobile users.
 */
import { useEffect, useState } from "react";
import Link from "next/link";
import { useT } from "@/lib/locale";

export default function FloatingCTA() {
  const t = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > 800);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-40 lg:hidden">
      {/* Same entry contract as the hero + persona CTAs: the "Enter the preview"
          label goes straight to /home (L4), not /sign-in. Sign-in stays reachable
          + honestly labelled via the footer and the Ask-Pelican recovery copy. */}
      <Link
        href="/home"
        className="btn-primary shadow-lg backdrop-blur-sm text-sm"
      >
        {t("hero.enterGeneric")}
      </Link>
    </div>
  );
}
